import type { Callback, Unsubscribe } from '@mfe/lib/store/state';
import { TemplatingMixin } from '@mfe/lit/mixins/TemplatingMixin';
import { consentStore } from '@mfe/store';
import { DEFAULT_MSISDN_FILTER } from '@mfe/store/ConsentStore';
import {
  LitElement,
} from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('tef-coms-button')
export class TefComsButton extends TemplatingMixin(LitElement) {
  @property({ type: String }) text : string = 'Default Button Text';
  @state() disabled : boolean = false;

  unsubscribe : Unsubscribe;

  constructor() {
    super();
    this.unsubscribe = consentStore.subscribe(this.handleChosenMsisdnUpdate.bind(this) as Callback, ['chosenMsisdn']);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.unsubscribe();
  }

  handleChosenMsisdnUpdate() {
    if (consentStore.chosenMsisdn !== DEFAULT_MSISDN_FILTER) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }

  override render() {
    return this.getTemplateFn('tefComsButton')();
  }

  handleClick(event: PointerEvent) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }

  // Render into lightDOM
  protected createRenderRoot() {
    return this;
  }
}
